import React, { useState, useEffect } from 'react';
import './InstallPrompt.css';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    const dismissedUntil = localStorage.getItem('pwa-install-dismissed');
    if (dismissedUntil && Date.now() < parseInt(dismissedUntil)) {
      setDismissed(true);
      return;
    }

    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setTimeout(() => setShowPrompt(true), 5000);
    };

    const handleInstalled = () => {
      setIsInstalled(true);
      setShowPrompt(false);
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    window.addEventListener('appinstalled', handleInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
      window.removeEventListener('appinstalled', handleInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShowPrompt(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa-install-dismissed', Date.now() + (7 * 24 * 60 * 60 * 1000));
    setDismissed(true);
  };

  if (isInstalled || dismissed || !showPrompt || !deferredPrompt) return null;

  return (
    <div className="install-prompt-overlay">
      <div className="install-prompt">
        <button className="install-prompt-close" onClick={handleDismiss}>&times;</button>
        <div className="install-prompt-icon">
          <img src="/icon-192.png" alt="POSBerry" />
        </div>
        <h3>Instalar POSBerry CRM</h3>
        <p>
          Accede mas rapido con la app instalada.
          <br /><strong>✓</strong> Notificaciones push
          <br /><strong>✓</strong> Funciona sin conexion
          <br /><strong>✓</strong> Acceso directo
        </p>
        <div className="install-prompt-actions">
          <button className="install-btn-primary" onClick={handleInstall}>Instalar App</button>
          <button className="install-btn-secondary" onClick={handleDismiss}>Ahora no</button>
        </div>
      </div>
    </div>
  );
};

export default InstallPrompt;
